/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { isValidDigit } from "../../../utils/validations";
import { JAVA_MAX_VALUE } from "../../../globals/globals";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

export const RadioNodeReplace: React.FC = () => {
    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    const onInputChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === "oldRadioNodeId") {
            if (!!value) {
                if (!isValidDigit(value) || Number(value) < 0 || Number(value) > JAVA_MAX_VALUE) {
                    dispatch(setErrorMsg({ [name]: "Radio Node ID is invalid!" }));
                }
            } else {
                dispatch(setErrorMsg({ [name]: "Radio Node ID is required!" }));
            }
        }
        if (name === "newRadioNodeId") {
            if (!!value) {
                if (!isValidDigit(value) || Number(value) < 0 || Number(value) > JAVA_MAX_VALUE) {
                    dispatch(setErrorMsg({ [name]: "With Radio Node ID is invalid!" }));
                }
            } else {
                dispatch(setErrorMsg({ [name]: "With Radio Node ID is required!" }));
            }
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <p className="text-sm font-medium">Select the radio node, node ID to replace.</p>
            <div>
                <InputField
                    label="Radio Node ID"
                    name="oldRadioNodeId"
                    value={scheduledtasks?.oldRadioNodeId ?? ""}
                    required
                    onChange={onInputChange}
                    onBlur={onBlurHandler}
                    placeholder="Enter radio node id"
                />
            </div>
            <div>
                <InputField
                    label="With Radio Node ID"
                    name="newRadioNodeId"
                    value={scheduledtasks?.newRadioNodeId ?? ""}
                    required
                    onChange={onInputChange}
                    onBlur={onBlurHandler}
                    placeholder="Enter with radio node id"
                />
            </div>
        </div>
    )
}